<template>
  <div class="chart-box" ref="chartRef" :style="`height:${height}`"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    height: {
      type: String,
      default: '350px'
    },
    option: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    window.addEventListener('resize', this.reSizeChart)
    this.initChart()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.reSizeChart)
  },
  methods: {
    initChart() {
      const dom = this.$refs.chartRef
      this.chart = echarts.init(dom,null,{renderer:'svg'})
      this.chart.setOption(this.option)
    },
    reSizeChart() {
      this.chart.resize()
    }
  },
  watch: {
    option: {
      handler(val) {
        if (!val || JSON.stringify(val) == '{}') return
        this.chart.setOption(val)
        this.reSizeChart()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.chart-box {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/hospitalUserManage/components/chart.vue